import { makeRequest, CommonRequestOptions } from '../makeRequest';
import { QuizQuestionJson } from './getQuiz';

export type QuizQuestionResultType = {
   question_json: string;
   question: QuizQuestionJson;
   response_json: string | null;
   isCorrect: boolean;
   number?: number;
   otherInputValue: string | null;
   pageOrder: number;
   takenOrder: number;
   translatedGrading: boolean;
   shouldBeCounted: boolean;
};
export type GetQuizSubmissionResponse = {
   quizid: number;
   quiz_revisionid: number;
   guideid: number;
   guide_revisionid: number;
   guide_title: string;
   doc_title: string;
   docid: number;
   score: number;
   passing_score: number;
   passed: boolean;
   results: QuizQuestionResultType[];
   userid: number;
   end_date: number;
   attempts_remaining?: number;
   should_show_attempts_remaining: boolean;
   doctype: 'guide' | 'wiki';
};

export async function getQuizSubmission(
   quiz_sessionid: number,
   { ...common }: CommonRequestOptions = {}
): Promise<GetQuizSubmissionResponse> {
   return makeRequest('get', `/quizzes/submissions/${quiz_sessionid}`, {
      ...common,
   });
}
